import React from "react";

function SelectIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#000"
        fillOpacity="0.6"
        d="M13.833 2.633V14.3H2.167V2.633h11.666zm0-1.666H2.167C1.25.967.5 1.717.5 2.633V14.3c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V2.633c0-.916-.75-1.666-1.667-1.666z"
      ></path>
    </svg>
  );
}

export default SelectIcon;
